import { Component, Input } from '@angular/core';

@Component({
  selector: 'gcc-empty-state-wrapper',
  templateUrl: './empty-state-wrapper.component.html',
  styleUrls: ['./empty-state-wrapper.component.scss']
})
export class EmptyStateWrapperComponent {
  @Input() public isData: boolean;
  @Input() public heading: string;
  @Input() public description: string;
  @Input() public imgPath = 'assets/images/empty/ill-no-data.svg';
  @Input() public addRoute: string;
}
